import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import DifferentObjectWebhookEventsTable from 'automation-ui-enrollment/components/eventEnrollment/webhooks/DifferentObjectWebhookEventsTable';
import WebhookPanelFullWidthHR from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookPanelFullWidthHR';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhooksForDifferentObjectsView = ({
  webhooks,
  objectTypeId,
  setWebhookStagedForDeletion
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(WebhookPanelFullWidthHR, {}), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      isJsx: true,
      baseLangKey: "automation-ui-enrollment.redesign.events.webhookEvents.objectTypeCaveatHeader_cob",
      objectTypeId: objectTypeId,
      elements: {
        b: 'b'
      }
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      as: "div",
      children: /*#__PURE__*/_jsx(DifferentObjectWebhookEventsTable, {
        webhooks: webhooks,
        setWebhookStagedForDeletion: setWebhookStagedForDeletion
      })
    })]
  });
};
export default WebhooksForDifferentObjectsView;